import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  withStyles,
} from "@material-ui/core/";
import { useTranslations } from "adapters/i18n";
import React from "react";
import { DATE_FORMATS, DateUtils } from "shared/dateUtils";
import {
  DETAILS_MODAL_TABLE_COLUMNS,
  getDetailsModalTableColumns,
} from "../conciliacaoUtil";

export const ConciliationDetailsModalTable = ({ classes, operationItems }) => {
  const { t } = useTranslations();

  const tableColumns = getDetailsModalTableColumns(t);

  const columnCellStylesMap = {
    [DETAILS_MODAL_TABLE_COLUMNS.OPERATION_TYPE]: { width: "140px" },
    [DETAILS_MODAL_TABLE_COLUMNS.APP_PORTAL]: { width: "120px" },
    [DETAILS_MODAL_TABLE_COLUMNS.PASTURE]: { width: "140px" },
    [DETAILS_MODAL_TABLE_COLUMNS.DATE]: { width: "102px" },
    [DETAILS_MODAL_TABLE_COLUMNS.AMOUNT]: { width: "112px" },
    [DETAILS_MODAL_TABLE_COLUMNS.WEIGHT]: { width: "50px" },
    [DETAILS_MODAL_TABLE_COLUMNS.USER]: { width: "172px" },
  };

  return (
    <div className={classes.tableBox}>
      <div className={classes.tableWrapper}>
        <Table id="operations-history-table" className={classes.table}>
          <TableHead id="operations-history-table-header">
            <TableRow id="operations-history-table-cols">
              {tableColumns.map((col) => (
                <TableCell
                  key={`operations-history-table-col-${col.id}`}
                  align="center"
                  className={classes.header}
                  style={columnCellStylesMap[col.id] || null}
                >
                  {col.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody id="operations-history-table-body">
            {operationItems.map((rowData, index) => (
              <DetailsTableRow
                key={`details-table-row-${index}`}
                index={index}
                operationItem={rowData}
                rowClasses={classes.row}
              />
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

const DetailsTableRow = ({ index, operationItem, rowClasses }) => {
  const { t } = useTranslations();

  const { tooltipText, value: weight } = getWeightValue({ operationItem, t });

  const operationDate = DateUtils.parse(
    operationItem.DataOperacao || operationItem.DataRegistro
  ).format(DATE_FORMATS["DD/MM/YYYY"]);

  return (
    <TableRow id={`operations-history-table-row-${index}`}>
      <TableCell
        align="left"
        className={rowClasses}
        style={{ textTransform: "capitalize" }}
      >
        {operationItem.TipoOperacao}
      </TableCell>
      <TableCell align="center" className={rowClasses}>
        {operationItem.Origem}
      </TableCell>
      <TableCell align="center" className={rowClasses}>
        {operationItem.PastoOperacao ? operationItem.PastoOperacao.Nome : "-"}
      </TableCell>
      <TableCell align="center" className={rowClasses}>
        {operationDate}
      </TableCell>
      <TableCell align="center" className={rowClasses}>
        {operationItem.Quantidade}
      </TableCell>
      <TableCell align="center" className={rowClasses}>
        <Tooltip title={tooltipText} className={rowClasses}>
          <div width="50px" id={`peso-${index}`}>
            {weight}
          </div>
        </Tooltip>
      </TableCell>
      <TableCell
        align="center"
        className={rowClasses}
        style={{ wordBreak: "break-all" }}
      >
        {operationItem.UsuarioCriacao.includes("script:")
          ? t("common:system").toLowerCase()
          : operationItem.UsuarioCriacao}
      </TableCell>
    </TableRow>
  );
};

const getWeightValue = ({ operationItem, t }) => {
  if (operationItem.PesoMedido) {
    return {
      value: `${operationItem.PesoMedido} P`,
      tooltipText: t("livestock:measured-weight"),
    };
  }
  if (operationItem.PesoVisual === 0 || operationItem.PesoVisual === null) {
    return {
      value: "-",
      tooltipText: t("livestock:weight-not-recorded"),
    };
  }

  return {
    value: `${operationItem.PesoVisual} V`,
    tooltipText: t("livestock:visual-weight"),
  };
};

const styles = (theme) => ({
  tableBox: {
    boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.2)",
    height: "300px",
    overflow: "hidden",
    borderRadius: "16px",
  },
  tableWrapper: {
    overflow: "auto",
    maxHeight: 270,
  },
  table: {
    position: "relative",
    tableLayout: "fixed",
    width: "100%",
    borderRadius: "3px",
    border: "solid 0.5px #e5e5ea",
    boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.2)",
    background: "#fff",
  },
  header: {
    height: "auto",
    backgroundColor: "#e1e1e1",
    fontSize: "12px",
    color: theme.palette.primary.main,
    fontFamily: "Roboto",
    fontWeight: 500,
    letterSpacing: "1px",
    textTransform: "uppercase",
  },
  row: {
    fontFamily: "Roboto",
    fontSize: "14px",
    color: "#333333",
    // width: "45px",
  },
});

export default withStyles(styles)(ConciliationDetailsModalTable);
